export default __webpack_public_path__ + "static/media/Dr-Guenter-Dobrauz-Saldapenna.7ee3c58f.jpg";